import { render, staticRenderFns } from "./virtualMession.vue?vue&type=template&id=9b11952a&"
import script from "./virtualMession.vue?vue&type=script&lang=js&"
export * from "./virtualMession.vue?vue&type=script&lang=js&"
import style0 from "./virtualMession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports